import React from 'react';
import { FEATURED_FAQS } from '../../../content/faqs';

export default function FAQSection() {
  return (
    <section id="faq" className="py-20">
      <div className="max-w-7xl xl:max-w-[1600px] 2xl:max-w-[1800px] mx-auto px-6 lg:px-8">
        <div className="bg-card/30 backdrop-blur-sm border border-border rounded-2xl p-8 md:p-10">
          <div className="max-w-4xl mx-auto space-y-10">
            <div className="space-y-3 text-center">
              <h2 className="text-3xl sm:text-4xl font-bold text-foreground">Frequently Asked Questions</h2>
              <p className="text-muted-foreground">
                Short, factual answers designed to be easy for search engines and chatbots to understand.
              </p>
            </div>

            <div className="space-y-8">
              {FEATURED_FAQS.map((item) => (
                <div key={item.question} className="space-y-2">
                  <h3 className="text-lg sm:text-xl font-semibold text-foreground">{item.question}</h3>
                  <p className="text-muted-foreground">{item.answer}</p>
                </div>
              ))}
            </div>

            <div className="text-center">
              <a
                href="/faq"
                className="inline-flex items-center justify-center rounded-md border border-border bg-background/70 px-4 py-2 text-sm font-semibold text-foreground hover:bg-background/85 transition-colors"
              >
                View all FAQs
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

